import React from 'react';
import { List, Segment } from 'semantic-ui-react';

import { DetallesDelCurso } from '../tipos';

export const InformacionBasica = (props: { curso: DetallesDelCurso }) => {
    const { curso } = props;

    return (
        <Segment>
            <List relaxed>
                <List.Item>
                    <List.Icon name='calendar outline' />
                    <List.Content>{formatearHorario(curso)}</List.Content>
                </List.Item>

                <List.Item>
                    <List.Icon name='group' />
                    <List.Content>
                        {curso.inscritos} inscritos
                        {curso.recuperaciones.length > 0 && (
                            <>
                                ,{' '}
                                <a href='#lista_recuperaciones' style={{ fontWeight: 'bold' }}>
                                    {curso.recuperaciones.length} recuperando
                                </a>
                            </>
                        )}
                    </List.Content>
                </List.Item>

                <List.Item>
                    <List.Icon name='hashtag' />
                    <List.Content>{curso.capacidad} capacidad máxima</List.Content>
                </List.Item>
            </List>
        </Segment>
    );
};

const DIAS = ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'];

function formatearHorario(curso: DetallesDelCurso) {
    const dia = DIAS[curso.dia];
    return `${dia} ${curso.bloqueHorario.horaInicio} – ${curso.bloqueHorario.horaTermino}`;
}



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/Informacion/InformacionBasica.tsx